import { memo } from 'react';
export const TraderVip = memo(function TraderVip() {
    return <div>專業看盤室</div>;
});
